import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  connect() {
    this.timeout = null;
    this.url = new URL(this.element.dataset.searchUrl, window.location.origin);
  }

  throttledSearch(event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const query = event.target.value;
      if (query.length < 2 && query.length !== 0) {
        return; // don't search for very short queries
      }

      this.url.searchParams.set("query", event.target.value);
      this.url.searchParams.set("filter", event.target.dataset.scope);
      this.url.searchParams.set("sort", event.target.dataset.sort);

      get(this.url, {
        responseKind: "turbo-stream",
      });
    }, 300);
  }

  changeSort(event) {
    const sortValue = event.target.value;
    this.url.searchParams.set("sort", sortValue);
    this.url.searchParams.set("filter", event.target.dataset.scope);
    this.url.searchParams.set("query", event.target.dataset.query);

    get(this.url, {
      responseKind: "turbo-stream",
    });
  }
}
